export const USER_HINTS = {
    BUY_SELL: 'buy_sell',
    DEMO_LIMITS: 'demo_limits',
} as const;